import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import ContactPage from '@/pages/contact/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
